module.exports = function(h, row) {
    if (row.status == 0) {
        return <span class="label red">Inactive</span>;
    }
    if (row.status == 1) {
        return <span class="label green">Active</span>;
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/charge/status.jsx